import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Tabs, Tab } from "@mui/material";

import { useTranslation } from "react-i18next";

import HvacEditor from "./components/HvacEditor";
import AlertsEdit from "./components/AlertsEdit";
import FacilityView from "./components/FacilityEdit";
import ClientEdit from "./components/ClientEdit";
import OccupancyPointEditor from "./components/points/OccupancyPointEditor";
import PointEditor from "./components/points/PointEditor";

export default function Settings(props) {
    const { clientInfo, facility } = props;

    const { t } = useTranslation();

    const [activeTab, setActiveTab] = React.useState("points");

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <>
            <Stack>
                <Box
                    sx={{
                        borderBottom: 1,
                        marginBottom: 0,
                        borderColor: "divider",
                    }}
                >
                    <Tabs value={activeTab} onChange={handleTabChange}>
                        <Tab label={t("Points")} value="points" />
                        <Tab label={t("HVAC")} value="hvac" />
                        <Tab label={t("Occupancy")} value="occupancy" />
                        <Tab label={t("Alerts")} value="alerts" />
                        <Tab label={t("Facility")} value="facility" />
                        {new URLSearchParams(window.location.search).get(
                            "staff",
                        ) === "true" && (
                            <Tab label={t("Client")} value="client" />
                        )}
                    </Tabs>
                </Box>
                <Box>
                    {activeTab === "points" ? (
                        <Box p={3} height="calc(100vh - 120px)">
                            <PointEditor facility={facility} />
                        </Box>
                    ) : null}
                    {activeTab === "hvac" ? (
                        <Box p={3} height="calc(100vh - 120px)">
                            <HvacEditor facility={facility} />
                        </Box>
                    ) : null}
                    {activeTab === "occupancy" ? (
                        <Box p={3} height="calc(100vh - 120px)">
                            <OccupancyPointEditor facility={facility} />
                        </Box>
                    ) : null}
                    {activeTab === "alerts" ? (
                        <Box p={3} height="calc(100vh - 120px)">
                            <AlertsEdit facility={facility} />
                        </Box>
                    ) : null}
                    {activeTab === "facility" && (
                        <Box
                            sx={{
                                p: 3,
                                backgroundColor: (theme) =>
                                    theme.palette.grey[100],
                            }}
                        >
                            <FacilityView facility={facility} />
                        </Box>
                    )}
                    {activeTab === "client" && (
                        <Box
                            sx={{
                                p: 3,
                                backgroundColor: (theme) =>
                                    theme.palette.grey[100],
                            }}
                        >
                            <ClientEdit client={clientInfo} />
                        </Box>
                    )}
                </Box>
            </Stack>
        </>
    );
}
